export function componentName<N extends string>(name: N) {
  return {
    displayName: name,
  };
}
